/*
 * @Author: Ashley.Liu
 * @Date: 2022-11-01 13:26:58
 * @LastEditTime: 2022-11-01 13:36:34
 * @Description: desc
 */
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.css'
import 'codemirror/addon/search/jump-to-line'
